import React from 'react';
import PropTypes from 'prop-types';
import { FinancialProductRuleListWrapper } from './FinancialProductRuleListStyle';
import FinancialProductRuleListItem from './FinancialProductRuleListItem';
import Placeholder from 'components/common/Placeholder';
import { useTranslation } from 'react-i18next';

const FinancialProductRuleList = ({ financialProductRules, onEditLink, onDeleteLink, canWrite, isSaved }) => {
  const [t] = useTranslation();

  return (
    <>
      {isSaved && (
        <FinancialProductRuleListWrapper container>
          {financialProductRules.map((n, idx) => {
            return (
              <FinancialProductRuleListItem
                key={n.financialProductRuleId}
                t={t}
                item={n}
                index={idx}
                onEditLink={onEditLink}
                onDeleteLink={onDeleteLink}
                canWrite={canWrite}
              />
            );
          })}
        </FinancialProductRuleListWrapper>
      )}
      {!isSaved && <Placeholder message={t('FinancialProduct.Details.PleaseCompleteGeneralData')} color={'warning'} />}
    </>
  );
};

FinancialProductRuleList.propTypes = {
  financialProductRules: PropTypes.array.isRequired,
  onEditLink: PropTypes.func.isRequired,
  onDeleteLink: PropTypes.func.isRequired,
  canWrite: PropTypes.bool.isRequired,
  isSaved: PropTypes.bool.isRequired
};

export default FinancialProductRuleList;
